import * as React from "react";
import styled from "styled-components";
import DropdownTreeSelect, { TreeData, TreeNode } from "react-dropdown-tree-select";

import { themeValues } from "../../theme";
import { DefaultEmptyState } from "./DefaultEmptyState";
import { EmptyStateHOC, IComboBoxEmptyStateProps } from "./EmptyState";
import closeIcon from "../../Icon/svgs/closeIcon.inline.svg"

export const StyledTreeSelect = styled(DropdownTreeSelect)`
  .tag {
    background-color: #f4f4f4;
    border: 1px solid #e9e9e9;
    padding: 2px 0 2px 2px;
    border-radius: 2px;
    display: inline-block
  }

  .tag:focus-within {
    background-color: #e9e9e9;
    border-color: #a0a0a0
  }

  .tag-remove {
    color: #a0a0a0;
    font-size: 75%;
    line-height: 100%;
    cursor: pointer;
    background-color: transparent;
    border: none;
    outline: none
  }

  .tag-remove.disabled, .tag-remove.readOnly {
    cursor: not-allowed
  }

  .tag-remove:focus {
    color: #3c3c3c
  }

  .node > label {
    cursor: pointer;
    margin-left: 2px
  }

  .tag-list {
    display: inline;
    padding: 0;
    margin: 0
  }

  .tag-item {
    display: inline-block;
    margin: 4px
  }

  .tag-item .search {
    border: none;
    border-bottom: 1px solid #ccc;
    outline: none
  }

  .tag-item:last-child {
    margin-right: 4px
  }

  .node {
    list-style: none;
    white-space: nowrap;
    padding: 4px
  }

  .node.leaf.collapsed {
    display: none
  }

  .node.disabled > * {
    color: gray;
    cursor: not-allowed
  }

  .node.match-in-children.hide .node-label {
    opacity: .5
  }

  .node.focused {
    background-color: #f4f4f4
  }

  .toggle {
    white-space: pre;
    margin-right: 4px;
    cursor: pointer
  }

  .toggle:after {
    content: " "
  }

  .toggle.collapsed:after {
    content: "+"
  }

  .toggle.expanded:after {
    content: "-"
  }

  .searchModeOn .toggle {
    display: none
  }

  .checkbox-item, .radio-item {
    vertical-align: middle;
    margin: 0 4px 0 0
  }

  .checkbox-item.simple-select, .radio-item.simple-select {
    display: none
  }

  .hide:not(.match-in-children) {
    display: none
  }

  .react-dropdown-tree-select .dropdown {
    position: relative;
    display: table
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow {
    cursor: pointer
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.bottom:after {
    content: "\\25BC";
    vertical-align: middle;
    color: #3c3c3c;
    margin-right: 2px
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.top:after {
    content: "\\25B2";
    vertical-align: middle;
    color: #3c3c3c;
    margin-right: 2px
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.disabled {
    cursor: not-allowed
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.disabled.bottom:after {
    color: #b9b9b9
  }

  .react-dropdown-tree-select .dropdown .dropdown-content {
    position: absolute;
    padding: 4px;
    z-index: 1;
    background: #fff;
    border-top: 1px solid rgba(0, 0, 0, .05);
    -webkit-box-shadow: 0 5px 8px rgba(0, 0, 0, .15);
    box-shadow: 0 5px 8px rgba(0, 0, 0, .15)
  }

  .react-dropdown-tree-select .dropdown .dropdown-content .search {
    width: 100%;
    border: none;
    border-bottom: 1px solid #ccc;
    outline: none
  }

  .react-dropdown-tree-select .dropdown .dropdown-content ul {
    margin: 0;
    padding: 0
  }

  /*# sourceMappingURL=styles.css.map*/
  /* */
  &.disabled {
    .dropdown, .search {
      opacity: 0.75;
      background-color: #f0f3f6;
    }
  }
  
  &.react-dropdown-tree-select {
    .dropdown {
      width: 100%;
      position: initial;
    }

    & .dropdown-content {
      position: relative !important;
      max-height: 200px;
      overflow-y: auto;
      margin-top: 4px;
      width: 100%;
      padding: 8px 0 !important;
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
      border: 1px solid #e4e5e8;
      border-radius: 4px;

      & .no-matches {
        text-align: center;
        font-size: 14px;
        line-height: 16px;
        display: block;
        padding: 8px 0;
      }

      & .node.leaf {
        padding: 0;

        & i {
          display: none;
        }

        & label {
          width: 100%;
          display: flex;
          align-items: center;
          padding: 8px 16px;
          margin: 0;

          & .node-label {
            color: #000;
            font-size: 14px;
            line-height: normal;
          }

          & input {
            cursor: pointer;
            margin-right: 16px;
          }
        }

        &:hover {
          background-color: #f8f8f8;
        }
      }
    }

    & .dropdown .dropdown-trigger {
      padding: 4px;
      line-height: 20px;
      max-height: 200px;
      display: inline-block;
      overflow: auto;
      border: 1px solid #b9b9b9;
      
      padding: 6px 16px;
      border: 1px solid #e4e5e8;
      border-radius: 4px;
      overflow: initial;
      width: 100%;
      transition: 0.2s ease;

      &:hover,
      &:focus-within {
        border-color: #aaa;
      }

      &.arrow.top::after,
      &.arrow.bottom::after {
        display: none;
      }

      & .tag-list {
        & .tag-item:first-child {
          margin-left: 0;
        }

        & .tag-item {
          & .search {
            border: none;
            font-size: 14px;
            line-height: 16px;
            color: #000;

            &::placeholder {
              color: #929da3;
            }
          }

          & .tag {
            border: 1px solid ${themeValues.primaryColor};
            border-radius: 50px;
            display: flex;
            align-items: center;
            padding: 0 0 0 8px;
            height: 18px;
            cursor: initial;
            background-color: #fff !important;
            color: #000;
            font-weight: 500;
            font-size: ${themeValues.fontSize.normal};
            line-height: 14px;

            & button.tag-remove {
              background-image: url(${closeIcon});
              background-size: 8px;
              background-position: center;
              background-repeat: no-repeat;
              width: 8px;
              height: 100%;
              background-color: transparent;
              border: none;
              cursor: pointer;
              outline: 0;
              padding: 3px 12px 3px 8px;
              transition: transform 0.2s ease;
              color: transparent;

              &:hover {
                transform: rotate(90deg);
              }
            }
          }
        }
      }
    }
  }
`;
StyledTreeSelect.displayName = "StyledTreeSelect";

interface IComboBoxProps {
  id: string;
  texts: {
    placeholder: string
    noMatches: string
  };
  data: TreeData[];
  onChange: (isNew: boolean, currentNode: TreeNode, selectedNodes: TreeNode[]) => void;
  emptyStateResolver?: boolean | React.ComponentType<IComboBoxEmptyStateProps>;
  loading?: boolean
}

/*
    TODO: react-dropdown-tree-select does not accept empty state components
          current hack pass it through noMatches text
*/
export function ComboBox({
                           id,
                           texts,
                           data: dataProp,
                           onChange: onChangeProp,
                           emptyStateResolver,
                           loading,
                         }: IComboBoxProps): JSX.Element {
  const comboBoxInputSelector = `#${id}_trigger input`;

  function onEmptyStateClose(value: string) {
    if (!value) {
      return;
    }

    const customAdded = {
      label: value,
      value,
      checked: true
    } as TreeNode;

    onChangeProp(
      true,
      customAdded,
      [
        ...dataProp.filter(d => (d as TreeNode).checked) as TreeNode[],
        customAdded
      ]
    );
  }

  function onChange(current: TreeNode, selectedNodes: TreeNode[]) {
    onChangeProp(false, current, selectedNodes);
  }

  let noMatchesComponent;

  if (emptyStateResolver) {
    if (typeof emptyStateResolver == "boolean") {
      noMatchesComponent = DefaultEmptyState;
    } else {
      noMatchesComponent = emptyStateResolver;
    }
  }

  let noMatches;

  if (noMatchesComponent && emptyStateResolver) {
    const EmptyState = EmptyStateHOC(noMatchesComponent);
    noMatches = <EmptyState selector={comboBoxInputSelector} onCloseProp={onEmptyStateClose} />;
  } else {
    noMatches = texts.noMatches;
  }

  return <StyledTreeSelect
      id={id}
      data={dataProp}
      texts={{
        placeholder: texts.placeholder,
        noMatches: noMatches as string
      }}
      onChange={onChange}
      clearSearchOnChange
      // className={cn({
      //   "disabled": loading,
      // })}
      // className={styles}
      disabled={loading}
    />
}
